import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { axiosClient } from "../../../common/axios"
import TextLink from "../../../common/components/TextLink"
import LoadingPaper from "../components/LoadingPaper"
import PageTitle from "../components/PageTitle"

export default function ForgotPassword() {
  const [isLoading, setIsLoading] = useState(false)
  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState(null)

  function handleEmailChanged(e) {
    setEmail(e.target.value)
    setEmailError(null)
  }

  function handleResetPasswordButtonClicked() {
    setIsLoading(true)
    axiosClient
      .post("/users/api/password/reset/request/", { email })
      .then(() => navigate("/user/forgot-password-email-sent"))
      .catch(({ response: { data } }) => {
        setEmailError(data.email)
      })
      .then(() => setIsLoading(false))
  }

  const navigate = useNavigate()

  return (
    <>
      <PageTitle text="Reset your account password" />
      <LoadingPaper isLoading={isLoading}>
        <Typography variant="body1">
          Enter your email below to get an email with a password reset link.
        </Typography>
        <TextField
          label="Email Address"
          size="small"
          value={email}
          onChange={handleEmailChanged}
          error={!!emailError}
          helperText={emailError}
          sx={{ mt: 2 }}
          fullWidth
          required
        />
        <Button
          variant="contained"
          disabled={!email}
          onClick={handleResetPasswordButtonClicked}
          sx={{ mt: 4 }}
        >
          Get Password Reset Email
        </Button>
        <Typography variant="body1" sx={{ mt: 2, textAlign: "center" }}>
          Already have an account? <TextLink to="/user/log-in" text="Log in" />
        </Typography>
      </LoadingPaper>
    </>
  )
}
